import { useEffect, useState, createContext, useContext } from "react";

/* Light/dark toggle scoped to /access only — does NOT affect public site.
   The Access pages use the `access-light` and `access-dark` classes for surface
   colors instead of Tailwind's global `dark:` modifier. */

const STORAGE_KEY = "clinic-os-access-theme";
const Ctx = createContext({ theme: "dark", toggle: () => {} });

export const AccessThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(STORAGE_KEY) || "dark";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <Ctx.Provider value={{ theme, toggle, setTheme }}>
      <div className={theme === "light" ? "access-light" : "access-dark"}>
        {children}
      </div>
    </Ctx.Provider>
  );
};

export const useAccessTheme = () => useContext(Ctx);
